import { Diamond } from "lucide-react";
import { useLang } from "../i18n";

const Marquee = () => {
    const { t } = useLang();
    const row = [...t.marquee, ...t.marquee];
    return (
        <div data-testid="editorial-marquee" className="overflow-hidden border-y border-champagne/15 bg-navy-deep py-4">
            <div className="animate-marquee flex w-max items-center">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-center">
                        {row.map((word, i) => (
                            <span key={`${half}-${i}`} className="flex items-center">
                                <span className="px-8 font-serif text-sm tracking-[0.42em] text-ivory/70 uppercase md:text-base">
                                    {word}
                                </span>
                                <Diamond size={10} strokeWidth={1.3} className="text-champagne/70" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Marquee;
